import { createAction } from '@reduxjs/toolkit';

export const REMOVE_ALL_ORDER_PRODUCT = 'REMOVE_ALL_ORDER_PRODUCT';

export const removeAllOrderProduct = createAction(
    REMOVE_ALL_ORDER_PRODUCT,
    () => ({ payload: [] }),
);
